// extracted by mini-css-extract-plugin
export default {"empty":"styles_empty__4li+U","emptyContent":"styles_emptyContent__UWVll","emptyText":"styles_emptyText__+PdFo"};